// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"ffa5aff38957ecba43fa","258":"a941cbffc2770baf2572"}[chunkId] + ".js");